import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'

// Geist değişken fontları: self-host edilir, kurumsal ağda CDN'e çıkılmaz.
import '@fontsource-variable/geist'
import '@fontsource-variable/geist-mono'

import './theme/global.css'
import './ui/ui.css'

import { router } from './router'
import { UIProvider } from './ui'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Yetki ve bulunamadı hatalarında tekrar denemek anlamsız.
        const status = (error as { response?: { status?: number } })?.response?.status
        if (status && [400, 401, 403, 404, 409].includes(status)) return false
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <UIProvider>
        <RouterProvider router={router} />
      </UIProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
